/* eslint-disable @typescript-eslint/no-explicit-any */
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import React, { useEffect, useState } from 'react';
import Card from './Card';
import ButtonsNextPrevSlider from './ButtonsNextPrevSlider';

function getWindowDimensions() {
    if (typeof window !== 'undefined') {
        const { innerWidth: width } = window;
        return {
            width,
        };
    } else {
        return {
            width: null,
        };
    }
}

function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function Slider(props): JSX.Element {
    const { attribute, detailsAll, propSlider, select, setSelect, padding, origin } = props;
    const [inactiveNext, setInactiveNext] = useState(false);
    const [detectorMovil, setDetectorMovil] = useState(false);
    const [inactivePrev, setInactivePrev] = useState(true);
    const [slider, setSlider] = useState<any>();
    const { width } = useWindowDimensions();

    // con este funcion tomo las dimenciones de la pantalla para saber si es movil o escritorio
    useEffect(() => {
        if (width && width < 640) {
            setDetectorMovil(true);
        }
    }, []);
    useEffect(() => {
        const handlerSlider = (current) => {
            setSlider({
                ...slider,
                currentIndex: current ? current : 0,
                responsive: { 0: { items: 2 }, 1024: { items: 8 } },
                items: detailsAll.map((d) => {
                    return (
                        <Card
                            key={`card-slider-${d.id}`}
                            details={d}
                            attribute={attribute}
                            propCard={propSlider}
                            select={select}
                            setSelect={setSelect}
                            type="card"
                        />
                    );
                }),
            });
        };
        // valido que el componente sea llamado del slider de fecha para ralizar estas validaciones del current index del slider
        // para el caso que seleccionan una fecha que esta al final del slider lleve a la fecha seleccionada
        if (origin && origin === 'date' && select && select.id) {
            let current = 0;
            if (select.id >= 8 && !detectorMovil) {
                current = select.id - 7;
            }
            //en el caso que sea movil el indice lo divido entre dos por que la cantidad de tarjetas es la mitad en responsive
            if (detectorMovil) {
                current = Math.round(select.id / 2) - 1;
            }
            handlerSlider(current);
        } else {
            handlerSlider(0);
        }
    }, [detailsAll]);

    useEffect(() => {
        if (origin && origin === 'date' && select && select.id) {
            setSlider({ ...slider, currentIndex: select.id - 1 });
        } else if (origin && origin === 'date') {
            setSlider({ ...slider, currentIndex: 0 });
        }
    }, [origin]);

    const onSlideChanged = (e) => {
        // se valida si esta en responsive con detectorMovil y si el curren index del componente del slider no sea mayor al current index que permite en movil que es 8
        if (e.item > 8 && detectorMovil) {
            setSlider({ ...slider, currentIndex: Math.round(e.item / 2) - 1 });
        } else {
            setSlider({ ...slider, currentIndex: e.item });
        }
    };

    return (
        <>
            {slider && (
                <div className={`relative ${propSlider.height} z-30`} id="Slider">
                    {/**botones desplazamientos */}
                    <ButtonsNextPrevSlider
                        attribute={attribute}
                        inactiveNext={inactiveNext}
                        setInactiveNext={setInactiveNext}
                        inactivePrev={inactivePrev}
                        setInactivePrev={setInactivePrev}
                        slider={slider}
                        setSlider={setSlider}
                        propSlider={propSlider}
                    />{' '}
                    <div className={`relative z-30 ml-4 md:ml-7 lg:ml-7`}>
                        {' '}
                        <AliceCarousel
                            mouseTracking
                            disableDotsControls={true}
                            disableButtonsControls={true}
                            activeIndex={slider.currentIndex}
                            infinite={false}
                            onSlideChanged={onSlideChanged}
                            responsive={slider.responsive}
                            items={slider.items}
                            {...(padding && padding.left && { paddingLeft: padding.left })}
                            {...(padding && padding.right && { paddingRight: padding.right })}
                            keyboardNavigation={true}
                        />
                    </div>
                </div>
            )}
        </>
    );
}
